import { initializeTracing } from '@imprivata-cloud/common';
import getConfig from '../appConfigUtils';

const { ZIPKIN_TRACING_URL, OTLP_TRACING_URL, API_URL } = getConfig();
const workflowId =
  new URLSearchParams(window.location.search).get('workflowId') ?? '';

const tracingInit = initializeTracing({
  workflowId,
  serviceName: 'idp-web-ui',
  // ignoring .onnx files, they are related to paravision sdk and are cluttering the traces
  ignoreUrls: [/\/models\/.+\.onnx$/],
  propagateTraceHeaderCorsUrls: [RegExp(`^${API_URL}.+`)],
  ZIPKIN_TRACING_URL,
  OTLP_TRACING_URL,
});

export const {
  serviceName,
  updateWorkflowId,
  getWorkflowId,
  getProvider,
  getTracer,
} = tracingInit;
